// angular
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
// components
import { ButtonComponent } from '@core/components/button/button.component';
// utils
import { DialogRef } from '@core/shared/utils/dialog/dialog-ref';
import { DIALOG_DATA } from '@core/shared/utils/dialog/dialog-tokens';

@Component({
  selector: 'pwj-confirmation-dialog',
  standalone: true,
  imports: [ButtonComponent, TranslateModule, NgClass],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
})
export class ConfirmationDialogComponent {
  public title!: string;
  public description!: string;

  // dependencies
  private readonly dialogRef = inject(DialogRef);
  public readonly data: { title: string; description?: string } =
    inject(DIALOG_DATA);

  constructor() {
    this.title = this.data.title;
    if (this.data?.description) this.description = this.data.description;
  }

  close() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
